import React from 'react';
import { BiInfoCircle } from 'react-icons/bi';

import ChampDeTexte from '../../UI/ChampDeTexte/ChampDeTexte';
import CaseACocher from '../../UI/CaseACocher/CaseACocher';

import S from './DateRangeInput.module.scss';

const DateRangeInput = ({ argument, onChange }) => {
  const handleOptionChange = (field, value) => {
    const newOptions = {
      ...argument.options,
      [field]: value,
    };
    onChange('options', newOptions);
  };

  return (
    <div className={S.dateRangeContainer}>
      <div className={S.infoBox}>
        <BiInfoCircle size={16} />
        <span>
          Ce type d'argument permet de sélectionner une plage de dates (début et
          fin).
        </span>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Configuration</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Description</label>
          <ChampDeTexte
            valeur={argument.description || ''}
            changement={(e) => onChange('description', e.target.value)}
            placeholder="Description de l'argument"
            multiline={true}
            rows={2}
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.obligatoire || false}
            changement={(checked) => onChange('obligatoire', checked)}
            label="Argument obligatoire"
          />
        </div>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Options spécifiques</h6>

        <div className={S.gridTwo}>
          <div className={S.champGroupe}>
            <label className={S.label}>Date minimum (YYYY-MM-DD)</label>
            <ChampDeTexte
              type="date"
              valeur={argument.options?.minDate || ''}
              changement={(e) => handleOptionChange('minDate', e.target.value)}
            />
          </div>

          <div className={S.champGroupe}>
            <label className={S.label}>Date maximum (YYYY-MM-DD)</label>
            <ChampDeTexte
              type="date"
              valeur={argument.options?.maxDate || ''}
              changement={(e) => handleOptionChange('maxDate', e.target.value)}
            />
          </div>
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.includeTime || false}
            changement={(checked) => handleOptionChange('includeTime', checked)}
            label="Inclure l'heure (datetime)"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.allowSameDate !== false}
            changement={(checked) =>
              handleOptionChange('allowSameDate', checked)
            }
            label="Permettre que début = fin (même date)"
          />
        </div>
      </div>

      <div className={S.previewSection}>
        <h6 className={S.configTitle}>Aperçu de l'input utilisateur</h6>
        <div className={S.previewBox}>
          <div className={S.mockInput}>
            <div className={S.mockLabel}>
              {argument.nom || "Nom de l'argument"}
              {argument.obligatoire && <span className={S.required}>*</span>}
            </div>
            <div className={S.mockField}>
              Plage de dates
              {argument.options?.includeTime && ' + heures'}
            </div>
            {argument.description && (
              <div className={S.mockDescription}>{argument.description}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateRangeInput;
